/* =============================================================================
 * Popup: zaproszenie do ankiety  (Miamo)
 * ========================================================================== */

(function () {
  'use strict';

  /* ---------------------------------------------------------------- CONFIG */

  const CONFIG = {
    enabled: true,
    debug: false, // true = ignoruje cookie, licznik i daty kampanii

    survey: {
      url: 'https://app.useberry.com/t/CJJRN6N9cNKbmU/',
      openInNewTab: true
    },

    campaign: {
      // ISO 8601 z przesunięciem strefy, albo null
      startsAt: null,                           // np. '2026-09-20T09:00:00+02:00'
      endsAt: '2026-09-30T23:59:59+02:00'       // np. '2026-10-15T23:59:59+02:00'
    },

    targeting: {
      locales: ['pl'], // [] = wszystkie rynki
      excludedPaths: [
        { path: '/cart', includeSubpaths: true },
        { path: '/checkouts', includeSubpaths: true },
        { path: '/account', includeSubpaths: true }
      ]
    },

    trigger: {
      minPageviews: 3, // popup na 3. kwalifikującej się odsłonie
      delayMs: 3000    // opóźnienie już na tej odsłonie
    },

    memory: {
      cookieName: 'miamo_survey_2026_09',
      counterKey: 'miamo_survey_views',
      fallbackMaxAgeDays: 365 // gdy campaign.endsAt === null
    }
  };

  /* --------------------------------------------------------------- TREŚCI */

  const CONTENT = {
    heading: 'Wypełnij ankietę oraz zgarnij kupon o wartości 350 zł za udział w 45-60min rozmowie online',
    paragraphs: [
      'Chcemy lepiej zrozumieć kto i dlaczego kupuje u nas, żeby poprawić sklep, ofertę i komunikację - tak, żeby faktycznie było wygodniej i prościej.',
      'Dlatego przygotowaliśmy krótką ankietę <strong>(ok. 5 minut)</strong>.',
      'Na jej końcu możesz zgłosić się do 45-60-minutowej płatnej rozmowy z naszą badaczką, za który oferujemy: <strong>kupon o wartości 350 zł</strong> do wykorzystania w naszym sklepie Miamo.'
    ],
    cta: '👉 Weź udział w ankiecie',
    footnote: 'Wygodnie &amp; bezpiecznie',
    closeLabel: 'Zamknij okno'
  };

  /* ---------------------------------------------------------------- IKONY */

  const ICONS = {
    thumb:
      '<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z" fill="#F7FFD1"/>' +
      '<path d="M36.0013 23.8401L34.668 29.3334H42.4413C42.8553 29.3334 43.2636 29.4298 43.6339 29.6149C44.0042 29.8001 44.3262 30.0689 44.5746 30.4001C44.823 30.7313 44.9909 31.1157 45.065 31.5231C45.139 31.9304 45.1172 32.3493 45.0013 32.7467L41.8946 43.4134C41.7331 43.9673 41.3962 44.4539 40.9346 44.8001C40.473 45.1463 39.9116 45.3334 39.3346 45.3334H21.3346C20.6274 45.3334 19.9491 45.0525 19.449 44.5524C18.9489 44.0523 18.668 43.374 18.668 42.6667V32.0001C18.668 31.2928 18.9489 30.6146 19.449 30.1145C19.9491 29.6144 20.6274 29.3334 21.3346 29.3334H25.0146C25.5107 29.3332 25.997 29.1945 26.4186 28.933C26.8402 28.6716 27.1805 28.2977 27.4013 27.8534L32.0013 18.6667C32.6301 18.6745 33.249 18.8243 33.8117 19.1049C34.3745 19.3854 34.8665 19.7896 35.2512 20.287C35.6358 20.7845 35.9031 21.3624 36.033 21.9777C36.1628 22.5929 36.152 23.2296 36.0013 23.8401Z" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M25.332 29.3333V45.3333" stroke="#121212" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    close:
      '<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M0 14C0 6.26801 6.26801 0 14 0C21.732 0 28 6.26801 28 14C28 21.732 21.732 28 14 28C6.26801 28 0 21.732 0 14Z" fill="#F8F8F8"/>' +
      '<path d="M18 10L10 18" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"/>' +
      '<path d="M10 10L18 18" stroke="#121212" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>',
    shield:
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">' +
      '<path d="M16.6659 10.8333C16.6659 15 13.7492 17.0833 10.2825 18.2916C10.101 18.3532 9.9038 18.3502 9.72419 18.2833C6.24919 17.0833 3.33252 15 3.33252 10.8333V4.99997C3.33252 4.77895 3.42032 4.56699 3.5766 4.41071C3.73288 4.25443 3.94484 4.16663 4.16585 4.16663C5.83252 4.16663 7.91585 3.16663 9.36585 1.89997C9.5424 1.74913 9.76698 1.66626 9.99919 1.66626C10.2314 1.66626 10.456 1.74913 10.6325 1.89997C12.0909 3.17497 14.1659 4.16663 15.8325 4.16663C16.0535 4.16663 16.2655 4.25443 16.4218 4.41071C16.5781 4.56699 16.6659 4.77895 16.6659 4.99997V10.8333Z" fill="#15803D"/>' +
      '<path d="M7.5 10.0002L9.16667 11.6668L12.5 8.3335" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>'
  };

  /* ------------------------------------------------------------- NARZĘDZIA */

  function log() {
    if (!CONFIG.debug) return;
    const args = Array.prototype.slice.call(arguments);
    console.log.apply(console, ['[survey-popup]'].concat(args));
  }

  function getCookie(name) {
    const escaped = name.replace(/([.*+?^${}()|[\]\\])/g, '\\$1');
    const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function setCookie(name, value, maxAgeSeconds) {
    const parts = [
      name + '=' + encodeURIComponent(value),
      'path=/',
      'max-age=' + Math.floor(maxAgeSeconds),
      'SameSite=Lax'
    ];
    if (location.protocol === 'https:') parts.push('Secure');
    document.cookie = parts.join('; ');
  }

  // max-age dociągnięte do końca kampanii, żeby ciasteczko samo się posprzątało
  function seenMaxAge() {
    if (CONFIG.campaign.endsAt) {
      const end = Date.parse(CONFIG.campaign.endsAt);
      if (!isNaN(end)) {
        const secondsLeft = Math.floor((end - Date.now()) / 1000);
        if (secondsLeft > 60) return secondsLeft;
      }
    }
    return CONFIG.memory.fallbackMaxAgeDays * 86400;
  }

  // '/CART/?x=1' -> '/cart'
  function cleanPath(path) {
    let p = String(path).split('?')[0].split('#')[0].toLowerCase();
    p = p.replace(/\/+$/, '');
    return p || '/';
  }

  // dodatkowo ucina prefiks języka, np. '/uk/cart' -> '/cart'
  function currentPath() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    let p = location.pathname;
    if (root !== '/' && p.toLowerCase().indexOf(root.toLowerCase()) === 0) {
      p = '/' + p.slice(root.length);
    }
    return cleanPath(p);
  }

  function isExcludedPath() {
    const here = currentPath();
    return CONFIG.targeting.excludedPaths.some(function (rule) {
      const target = cleanPath(rule.path);
      if (here === target) return true;
      return !!rule.includeSubpaths && here.indexOf(target + '/') === 0;
    });
  }

  function isTargetedLocale() {
    const wanted = CONFIG.targeting.locales;
    if (!wanted || !wanted.length) return true;
    let locale = (window.Shopify && window.Shopify.locale) ||
      document.documentElement.getAttribute('lang') || '';
    locale = locale.toLowerCase().split('-')[0];
    return wanted.map(String.prototype.toLowerCase.call.bind(String.prototype.toLowerCase))
      .indexOf(locale) !== -1;
  }

  function isInCampaignWindow() {
    const now = Date.now();
    const start = CONFIG.campaign.startsAt ? Date.parse(CONFIG.campaign.startsAt) : NaN;
    const end = CONFIG.campaign.endsAt ? Date.parse(CONFIG.campaign.endsAt) : NaN;

    if (CONFIG.campaign.startsAt && isNaN(start)) log('Nieprawidłowy startsAt — pomijam warunek');
    if (CONFIG.campaign.endsAt && isNaN(end)) log('Nieprawidłowy endsAt — pomijam warunek');

    if (!isNaN(start) && now < start) return false;
    if (!isNaN(end) && now > end) return false;
    return true;
  }

  // licznik odsłon; bumpowany dopiero gdy cookie nie istnieje
  function bumpPageviews() {
    try {
      const n = (parseInt(sessionStorage.getItem(CONFIG.memory.counterKey), 10) || 0) + 1;
      sessionStorage.setItem(CONFIG.memory.counterKey, String(n));
      return n;
    } catch (e) {
      // storage zablokowany (tryb prywatny, ustawienia przeglądarki).
      // Wolimy pokazać popup niż nie pokazać go nikomu — zmień na 0, jeśli odwrotnie.
      log('sessionStorage niedostępny', e);
      return CONFIG.trigger.minPageviews;
    }
  }

  /* ----------------------------------------------------------------- STYLE */

  const CSS = [
    '.digi{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;padding:20px;opacity:0;transition:opacity .2s ease}',
    '.digi[hidden]{display:none}',
    '.digi.is-open{opacity:1}',
    '.digi__overlay{position:absolute;inset:0;z-index:0;background-color:rgba(0,0,0,.55); display: block !important;}',
    '.digi__dialog{position:relative;z-index:1;width:100%;max-width:640px;max-height:calc(100dvh - 40px);overflow-y:auto;background:#fff;border-radius:16px;padding:40px;box-shadow:0 24px 60px rgba(0,0,0,.2);text-align:center;transform:translateY(8px);transition:transform .2s ease}',
    '.digi.is-open .digi__dialog{transform:none}',
    '.digi__close{position:absolute;top:40px;right:40px;width:28px;height:28px;padding:0;border:0;background:none;cursor:pointer;line-height:0;border-radius:50%}',
    '.digi__close svg{width:32px;height:32px;}',
    '.digi__close:hover{opacity:.7}',
    '.digi__thumb{line-height:0;margin-bottom:16px}',
    '.digi__heading{margin:0 0 32px;font-size:20px;line-height:140%;font-weight:700;color:#121212;letter-spacing:0}',
    '.digi__body{text-align:left;color:#3d3d3d;font-size:16px;line-height:1.5}',
    '.digi__body p{margin:0 0 16px}',
    '.digi__body p:last-child{margin-bottom:0}',
    '.digi__body strong{font-weight:700;color:#121212}',
    '.digi__cta{display:inline-block;margin:32px 0 0;padding:12px 24px;background:#121212;color:#fff;border-radius:999px;font-size:16px;font-weight:600;line-height:150%;text-decoration:none;cursor:pointer;border:0}',
    '.digi__cta:hover{background:#2c2c2c;color:#fff}',
    '.digi__note{display:flex;align-items:center;justify-content:center;gap:8px;margin-top:12px;margin-bottom:0;font-size:14px;color:#6b6b6b}',
    '.digi__note svg{flex:0 0 auto}',
    '.digi :focus-visible{outline:2px solid #121212;outline-offset:3px}',
    'html.digi-locked,html.digi-locked body{overflow:hidden}',
    '@media (max-width:600px){.digi{padding:12px}.digi__dialog{padding:16px;border-radius:14px}.digi__heading{font-size:16px;line-height:150%;}.digi__thumb svg{width:56px;height:56px;}.digi__close{right:16px;top:16px;}}',
    '@media (prefers-reduced-motion:reduce){.digi,.digi__dialog{transition:none}}'
  ].join('');

  /* ----------------------------------------------------------------- POPUP */

  let el = null;
  let lastFocused = null;
  let isClicked = false;

  function build() {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);

    const wrap = document.createElement('div');
    wrap.className = 'digi';
    wrap.setAttribute('hidden', '');
    wrap.innerHTML =
      '<div class="digi__overlay" data-digi-close></div>' +
      '<div class="digi__dialog" role="dialog" aria-modal="true" aria-labelledby="digi-heading">' +
        '<button type="button" class="digi__close" data-digi-close aria-label="' + CONTENT.closeLabel + '">' + ICONS.close + '</button>' +
        '<div class="digi__thumb">' + ICONS.thumb + '</div>' +
        '<div class="digi__heading" id="digi-heading">' + CONTENT.heading + '</div>' +
        '<div class="digi__body">' + CONTENT.paragraphs.map(function (p) { return '<p>' + p + '</p>'; }).join('') + '</div>' +
        '<a class="digi__cta" data-digi-cta href="' + CONFIG.survey.url + '"' +
          (CONFIG.survey.openInNewTab ? ' target="_blank" rel="noopener"' : '') + '>' + CONTENT.cta + '</a>' +
        '<p class="digi__note">' + ICONS.shield + '<span>' + CONTENT.footnote + '</span></p>' +
      '</div>';

    document.body.appendChild(wrap);
    return wrap;
  }

  function trapFocus(e) {
    if (e.key === 'Escape') { close(); return; }
    if (e.key !== 'Tab' || !el) return;

    const items = el.querySelectorAll('a[href], button');
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];

    // focus wchodzi do popupu dopiero, gdy ktoś faktycznie naciśnie Tab
    if (!el.contains(document.activeElement)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
      return;
    }

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function open() {
    if (el) return;

    lastFocused = document.activeElement;
    el = build();
    el.removeAttribute('hidden');

    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.classList.add('digi-locked');

    document.addEventListener('keydown', trapFocus);
    el.addEventListener('click', onClick);

    if (!CONFIG.debug) setCookie(CONFIG.memory.cookieName, '1', seenMaxAge());
    log('pokazany');
  }

  function close() {
    if (!el) return;
    const node = el;
    el = null;

    node.classList.remove('is-open');
    document.documentElement.classList.remove('digi-locked');
    document.removeEventListener('keydown', trapFocus);

    setTimeout(function () { node.remove(); }, 200);
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  // TODO: tu podpiąć właściwą wysyłkę kliknięcia
  function trackCtaClick() {
    log('kliknięto w CTA');
  }

  function onClick(e) {
    if (e.target.closest('[data-digi-cta]')) {
      if (!isClicked) {
        isClicked = true;
        trackCtaClick();
      }
      if (CONFIG.survey.openInNewTab) close();
      return;
    }
    if (e.target.closest('[data-digi-close]')) close();
  }

  /* ------------------------------------------------------------------ INIT */

  function init() {
    if (window.__miamoSurveyPopup) return;
    window.__miamoSurveyPopup = true;

    if (!CONFIG.enabled) return;

    if (CONFIG.debug) {
      log('tryb debug — pomijam wszystkie warunki');
      setTimeout(open, CONFIG.trigger.delayMs);
      return;
    }

    // 1. cookie jako bramka — dalej nic nie zapisujemy
    if (getCookie(CONFIG.memory.cookieName)) return log('cookie obecne');

    // 2. warunki kontekstowe
    if (!isInCampaignWindow()) return log('poza oknem kampanii');
    if (!isTargetedLocale()) return log('inny rynek');
    if (isExcludedPath()) return log('ścieżka wykluczona:', currentPath());

    // 3. licznik odsłon
    const views = bumpPageviews();
    log('odsłona', views, 'z', CONFIG.trigger.minPageviews);
    if (views < CONFIG.trigger.minPageviews) return;

    setTimeout(open, CONFIG.trigger.delayMs);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();